import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useConfig, useMenuItemRenderer, useOnClickOutside } from '../../hooks';
import { useStores } from '../../stores';
import DropDown from '../DropDown';
import DropDownItem from '../DropDownItem';
import IconButton from '../IconButton';
import CaretDownIcon from '../Icons/CaretDown';
import Scrollbar from '../Scrollbar';
import { ControlsItem } from './Controls';

const LanguagesMenu = ({ items = [], ...props }) => {
  const ref = React.useRef();
  const scrollbarRef = React.useRef(null);
  const {
    header: {
      title: { color, iconColor }
    },
    window: { colors },
    scrollBar: scrollbarConfig
  } = useConfig();
  const { i18n, t } = useTranslation();
  const stratedLanguage = items.find(item => item.default);
  const [currentLanguage, setCurrentLanguage] = React.useState({
    position: 1,
    name: stratedLanguage.name,
    label: stratedLanguage.label,
    icon: stratedLanguage.icon
  });
  const { app, network } = useStores();
  const [isOpen, setOpen] = React.useState(false);
  const renderMenuItem = useMenuItemRenderer();

  useOnClickOutside(ref, () => setOpen(false));

  React.useEffect(() => {
    i18n.changeLanguage(currentLanguage.name);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const [lang] = items.filter(item => item.name === i18n.language);

    if (lang) {
      app.setIsChangeLanguage(true, i18n.language);
      setCurrentLanguage(lang);
    }
  }, [app, i18n.language, items]);

  const languageName = currentLanguage.name.split('-')[0];

  return (
    <ControlsItem ref={ref} {...props}>
      <IconButton
        disabled={network.isOffline || network.isSlowConnection}
        onClick={() => setOpen(!isOpen)}
        title={i18n.exists('altText.languageMmenu') ? t('altText.languageMmenu') : ''}
      >
        <LanguageName>{languageName}</LanguageName>
        <CaretDownIcon fill={iconColor || color} />
      </IconButton>
      {isOpen && (
        <DropDown>
          <Scrollbar ref={scrollbarRef} autoHeight autoHeightMax={170} {...scrollbarConfig}>
            {items
              .map((item, idx) => (
                <DropDownItem
                  key={idx}
                  onClick={() => setOpen(false)}
                  textColor={colors.main}
                  hoverTextColor={colors.accent}
                >
                  {renderMenuItem(item, idx)}
                </DropDownItem>
              ))}
          </Scrollbar>
        </DropDown>
      )}
    </ControlsItem>
  );
};

const LanguageName = styled.span`
  text-transform: uppercase;
`;

export default observer(LanguagesMenu);
